import React, { Component } from 'react';
import SelectorModel from "./SelectorModel";
import SelectorLock from "./SelectorLock";
import SelectorEdit from "./SelectorEdit";
import SelectorDraggable from "./SelectorDraggable";

export default class Selector extends Component {

    state = {
    };

    style = ""

    constructor(props, context) {
        super(props, context);
    }

    componentWillMount() {

        this.designer = this.props.designer;
        this.unregisterResolutionChangedListener = this.designer.registerResolutionChangedListener(c => {
            this.updateLayout();
        });
        this.unregisterExtentChangedListener = this.designer.registerExtentChangedListener(c => {
            this.updateLayout();
        });
        this.unregisterPropertyChangedListener = this.props.model.registerPropertyChangedListener((name, valOld, valNew) => {
            this.updateLayout();
            setTimeout(() => {
                this.updateLayout();
            }, 0);
            if (name === "isLock" || name === "isEdit" || name === "layoutMode")
                this.setState({});
        })

        setTimeout(() => {
            this.dom = document.getElementById(`selector-${this.props.id}`);
            if (!this.dom)
                return;
            this.dom.setAttribute("style", this.style);
            this.updateLayout();
        }, 0);
    }

    componentWillUnmount() {
        this.unregisterResolutionChangedListener();
        this.unregisterExtentChangedListener();
        this.unregisterPropertyChangedListener();
    }

    updateLayout() {

        const extent = this.designer.extent;
        const resolution = this.designer.resolution;

        let { x, y } = this.props.model.getViewLocation();
        let { width, height } = this.props.model.getViewSize();

        let sx = (x - extent.left) / resolution - 1;
        let sy = (y - extent.top) / resolution - 1;

        let sw = width / resolution + 2;
        let sh = height / resolution + 2;

        this.style = `left: ${sx}px; top: ${sy}px; width: ${sw}px; height: ${sh}px; visibility: visible;`;
        if (!this.dom)
            return;

        this.dom.setAttribute("style", this.style);
    }

    renderSelector() {

        if (this.props.model.isEdit)
            return <SelectorEdit designer={this.props.designer} />;
        else if (this.props.model.isLock || this.props.model.layoutMode === "flex")
            return <SelectorLock designer={this.props.designer} />;
        else
            return <SelectorDraggable model={this.props.model} designer={this.props.designer} />;
    }

    render() {

        const has = this.props.model.isDefaultSelectorEnabled && this.props.model.isDefaultSelectorEnabled();

        return (
            <div id={`selector-${this.props.id}`} className={"selector " + (this.props.className || "")} >
                {
                    has === false ? undefined : this.renderSelector()
                }
                {
                    this.props.model.getSelector && this.props.model.getSelector(this.props.designer)
                }
            </div>
        );
    }
}
